import { useState } from 'react';
import { compose } from 'redux';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
import { toBackendLang } from '@plone/volto/helpers/Utils/Utils';
import Image from '@plone/volto/components/theme/Image/Image';

import cx from 'classnames';
import { useIntl, defineMessages } from 'react-intl';

import { Select } from 'semantic-ui-react';

import myFeLogo from './my_fe_logo.png';

import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

const MyFeCardTabContent = ({ color, moment: momentlib, reactDates }) => {
  const moment = momentlib.default;
  const { SingleDatePicker } = reactDates;
  const intl = useIntl();

  const [date, setDate] = useState(null);
  const [duration, setDuration] = useState(null);
  const [focused, setFocused] = useState(false);

  const durationOptions = [
    { key: 0, value: null, text: '-' },
    { key: 2, value: 2, text: '2' },
    { key: 3, value: 3, text: '3' },
    { key: 6, value: 6, text: '6' },
  ];

  const buyMyFeLink = `https://myfecard.tm.vivaticket.com/biglietteria/listaEventiPub.do?tipoPagina=1&idOwner=15738${date ? `&data=${moment(date).format('YYYYMMDD')}` : ''}&codice=${duration ? `10${duration}` : ''}&lang=${intl.locale}`;

  return (
    <div>
      <div className="top-info">
        <p>
          {intl.formatMessage(messages.prenotazioni_my_fe_card_descr, {
            strong: (chunks) => <strong>{chunks}</strong>,
          })}
        </p>
        <div className="logo">
          <Image src={myFeLogo} width="100" alt="" loading="lazy" />
        </div>
      </div>

      <div className="form-container">
        <div className={cx(`field ${color}`)}>
          <label htmlFor="date-field">
            {intl.formatMessage(messages.data_field_label)}
          </label>
          <SingleDatePicker
            date={date}
            onDateChange={(date) => setDate(date)}
            numberOfMonths={1}
            noBorder
            displayFormat={moment
              .localeData(toBackendLang(intl.locale))
              .longDateFormat('L')}
            onFocusChange={({ focused }) => setFocused(focused)}
            focused={focused}
            id="date-field"
            placeholder={intl.formatMessage(messages.data_field_placeholder)}
            openDirection="down"
            showDefaultInputIcon
            className={color}
          />
        </div>
        <div className="field">
          <label htmlFor="duration-field">
            {intl.formatMessage(messages.duration_field_label)}
          </label>
          <Select
            placeholder={intl.formatMessage(
              messages.duration_field_placeholder,
            )}
            aria-label="prova"
            options={durationOptions}
            value={duration}
            clearable={true}
            onChange={(e, data) => setDuration(data.value)}
            id="duration-field"
          />
        </div>
        <div className="field button">
          <UniversalLink
            href={buyMyFeLink}
            className={cx(`ui button ${color}`)}
          >
            {intl.formatMessage(messages.buy_my_fe_card_button)}
          </UniversalLink>
        </div>
      </div>
    </div>
  );
};

export default compose(injectLazyLibs(['reactDates', 'moment']))(
  MyFeCardTabContent,
);

const messages = defineMessages({
  prenotazioni_my_fe_card_descr: {
    id: 'prenotazioni_my_fe_card_descr',
    defaultMessage:
      '<strong>MyFE Card</strong> è la carta turistica di Ferrara, un unico pass che ti permette di vivere a pieno la città, risparmiando tempo e denaro. E se pernotti a Ferrara hai diritto all’esenzione dall’imposta di soggiorno.',
  },
  data_field_placeholder: {
    id: 'data_field_placeholder',
    defaultMessage: 'Selezionare una data',
  },
  data_field_label: {
    id: 'data_field_label',
    defaultMessage: 'Data',
  },
  duration_field_placeholder: {
    id: 'duration_field_placeholder',
    defaultMessage: '-',
  },
  duration_field_label: {
    id: 'duration_field_label',
    defaultMessage: 'Durata',
  },
  buy_my_fe_card_button: {
    id: 'buy_my_fe_card_button',
    defaultMessage: 'Acquista MyFe Card',
  },
});
